

import { EMOTIONS_LIST } from "@/lib/constants";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import SettingsStore from "@/stores/SettingsStore";
import type { VoiceEmotion } from "@/types/TAvatarSettings";
import { useTranslation } from "react-i18next";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function VoiceEmotionSelect() {
  const { t } = useTranslation();
  const voiceEmotion = SettingsStore(state => state.voiceEmotion);
  const setVoiceEmotion = SettingsStore(state => state.setVoiceEmotion);
  const isLoading = SettingsStore(state => state.isLoading);

  return (
    <ControlWrapper>
      <Label htmlFor="voice-emotion">{t("settings.voiceEmotion")}</Label>
      <Select
        value={voiceEmotion}
        onValueChange={(value) => setVoiceEmotion(value as VoiceEmotion)}
        disabled={isLoading}
      >
        <SelectTrigger id="voice-emotion" className="w-full">
          <SelectValue placeholder={t("settings.voiceEmotion")} />
        </SelectTrigger>
        <SelectContent>
          {EMOTIONS_LIST.map((emotion) => (
            <SelectItem
              key={emotion.key}
              value={emotion.value}
            >
              {t(`emotions.${emotion.key}`)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </ControlWrapper>
  );
}